<template>
  <div>
    <v-overlay
      absolute
      class="d-flex flex-column text-center"
      opacity="0.35"
      z-index="1"
      :value="datosNew.length === 0"
    >
      <div>
        <v-progress-circular width="2" size="50" color="white" indeterminate>
          <v-icon size="30">mdi-timer-sand</v-icon>
        </v-progress-circular>
      </div>
      Cargando Datos...
    </v-overlay>
    <v-data-table
      :headers="headers"
      v-if="datosNew.length !== 0"
      :items="datosNew"
      :items-per-page="5"
      hide-default-footer
      disable-filtering
      class="elevation-1"
      disable-sort
      mobile-breakpoint="800"
    ></v-data-table>
  </div>
</template>

<script>
import { format } from "../../static/funciones";
import { mapState } from "vuex";
export default {
  data() {
    return {
      headers: [
        {
          text: "En Transito",
          align: "start",
          sortable: false,
          value: "MontoPedTransito",
        },
        { text: "En Backorder", value: "MontoPedBackorder" },
        { text: "Pendientes de Cobro", value: "MontoPedPenCobro" },
      ],
    };
  },
  methods: {
    format,
  },
  computed: {
    ...mapState(["Cliente", "simboloMoneda", "tipoMoneda", "DetalleCliente"]),
    SaldoInfo: function () {
      return function (idKey) {
        let datos = null;
        if (Object.entries(this.DetalleCliente).length !== 0) {
          let { ttResumen: ttResumen } = this.DetalleCliente;
          if (ttResumen !== undefined) {
            datos = ttResumen[0][idKey][this.tipoMoneda];
          }
        }
        return datos;
      };
    },
    datosNew() {
      let xdata = [];
      if (Object.entries(this.Cliente).length !== 0) {
        let { resumen: resumen } = this.Cliente;
        if (Object.entries(resumen).length !== 0) {
          xdata = [
            {
              MontoPedTransito: `${this.format(
                this.SaldoInfo(`MontoPedTransito`),
                1
              )} ${this.simboloMoneda[this.tipoMoneda]}`,
              MontoPedBackorder: `${this.format(
                this.SaldoInfo(`MontoPedBackorder`),
                1
              )} ${this.simboloMoneda[this.tipoMoneda]}`,
              MontoPedPenCobro: `${this.format(
                this.SaldoInfo(`MontoPedPenCobro`),
                1
              )} ${this.simboloMoneda[this.tipoMoneda]}`,
            },
          ];
        }
      }
      return xdata;
    },
  },
};
</script>